import { create } from "zustand";

export interface PdfProgress {
  completed: number;
  total: number;
  succeeded: number;
  failed: number;
  percent: number;
  statusMessage: string;
  currentPaper: string | null;
}

interface PdfState {
  isRetrieving: boolean;
  isCompleted: boolean;
  error: string | null;
  jobId: string | null;
  progress: PdfProgress;

  startRetrieving: (jobId: string, total: number) => void;
  updateProgress: (update: Partial<PdfProgress>) => void;
  completeRetrieving: (message: string) => void;
  failRetrieving: (error: string) => void;
  resetRetrieving: () => void;
}

const initialProgress: PdfProgress = {
  completed: 0,
  total: 0,
  succeeded: 0,
  failed: 0,
  percent: 0,
  statusMessage: "",
  currentPaper: null,
};

export const usePdfStore = create<PdfState>((set, get) => ({
  isRetrieving: false,
  isCompleted: false,
  error: null,
  jobId: null,
  progress: { ...initialProgress },

  startRetrieving: (jobId, total) =>
    set({
      isRetrieving: true,
      isCompleted: false,
      error: null,
      jobId,
      progress: {
        ...initialProgress,
        total,
        statusMessage: "Starting PDF retrieval...",
      },
    }),

  updateProgress: (update) =>
    set((state) => ({
      progress: { ...state.progress, ...update },
    })),

  completeRetrieving: (message) =>
    set({
      isRetrieving: false,
      isCompleted: true,
      progress: { ...get().progress, statusMessage: message, percent: 100 },
    }),

  failRetrieving: (error) =>
    set({
      isRetrieving: false,
      error,
    }),

  resetRetrieving: () =>
    set({
      isRetrieving: false,
      isCompleted: false,
      error: null,
      jobId: null,
      progress: { ...initialProgress },
    }),
}));
